import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const maintenanceWorkflowSchedulesExecutionOptions = [
  { label: 'Quilometros percorridos', value: 'kilometers_usage' },
  { label: 'Dias passados', value: 'days' },
  { label: 'Horas passadas', value: 'hours_usage' },
]

export const maintenanceWorkflowSchedulesExecutionStrategy = optionsToStrategy(maintenanceWorkflowSchedulesExecutionOptions)
